import React from 'react';
import styled from 'styled-components';
import { Title } from '../Title/Title';
import { Paragraph } from '../Paragraph/Paragraph';
import { useParseHtmlLineBreaks } from '../../../../../hooks/useParseHtmlLineBreaks';
import { useParseHtmlStrong } from '../../../../../hooks/useParseHtmlStrong';

interface HeaderWrapperProps {
  titleText?: string | React.ReactNode;
  paragraphText?: string | React.ReactNode;
  color?: 'light' | 'dark';
}

export const HeaderWrapper: React.FC<HeaderWrapperProps> = ({
  titleText,
  paragraphText,
  color,
}) => {
  const parsedTitle = useParseHtmlLineBreaks(typeof titleText === 'string' ? titleText : '');
  const strongParsed = useParseHtmlStrong(typeof paragraphText === 'string' ? paragraphText : '');

  const parsedParagraph = typeof paragraphText === 'string' ? strongParsed : paragraphText;

  return (
    <BoxHeaderWrapper>
      <Title textWithBreaks={parsedTitle} color={color} />
      <Paragraph textWithStrong={parsedParagraph} color={color} />
    </BoxHeaderWrapper>
  );
};

const BoxHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  backround-color: red;
  gap: 14px;

  @media (min-width: 768px) {
    gap: 20px;
  }
`;
